import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	formControl: {
		"& .MuiOutlinedInput-root": {
			height: 40,
			minHeight: 40,
			maxHeight: 40,
			borderRadius: 8,
			fontSize: "0.82rem",
			backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.03)" : "#FFFFFF",
			boxSizing: "border-box",
			display: "flex",
			alignItems: "center",
			transition: "border-color 0.2s, box-shadow 0.2s",
			"&:hover": {
				borderColor: theme.palette.primary.main,
			},
			"&.Mui-focused": {
				boxShadow: `0 0 8px ${theme.palette.primary.main}40`,
			},
		},
		"& .MuiSelect-select": {
			display: "flex",
			alignItems: "center",
			height: "100%",
			padding: "0 28px 0 10px !important",
			boxSizing: "border-box",
		},
		"& .MuiInputLabel-outlined": {
			fontSize: "0.82rem",
			transform: "translate(14px, 12px) scale(1)",
			"&.MuiInputLabel-shrink": {
				transform: "translate(14px, -6px) scale(0.75)",
			},
		},
	},
	chips: {
		display: "flex",
		flexWrap: "nowrap",
		alignItems: "center",
		overflow: "hidden",
		gap: 3,
		maxHeight: 26,
	},
	chip: {
		margin: "1px 2px",
		fontSize: "0.75rem",
		height: 24,
		maxHeight: 24,
		fontWeight: 600,
		borderRadius: 12,
		color: "#FFFFFF",
		fontFamily: theme.typography.fontFamily,
		boxSizing: "border-box",
		"& .MuiChip-label": {
			padding: "0 8px",
			fontSize: "0.75rem",
			fontWeight: 600,
		},
	},
})); 

const QueueSelectCustom = ({ selectedQueueIds, onChange, style }) => {
	const classes = useStyles();
	const [queues, setQueues] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/queue");
				setQueues(data);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	const handleChange = e => {
		onChange(e.target.value);
	};

	return (
		<div style={style || { marginTop: 0 }}>
			<FormControl fullWidth size="small" variant="outlined" className={classes.formControl}>
				<InputLabel id="queue-select-custom-label">{i18n.t("queueSelect.inputLabel")}</InputLabel>
				<Select
					labelId="queue-select-custom-label"
					multiple
					label={i18n.t("queueSelect.inputLabel")}
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={selected => (
						<div className={classes.chips}>
							{selected?.length > 0 &&
								selected.map(id => {
									if (id === "0") {
										return (
											<Chip
												key={id}
												size="small"
												label={i18n.t("queueSelect.withoutQueue")}
												className={classes.chip}
											/>
										);
									}
									const queue = queues.find(q => q.id === id);
									return queue ? (
										<Chip
											key={id}
											size="small"
											style={{ backgroundColor: queue.color, color: "#FFFFFF" }}
											label={queue.name}
											className={classes.chip}
										/>
									) : null;
								})}
						</div>
					)}
				>
					<MenuItem value="0">
						{i18n.t("queueSelect.withoutQueue")}
					</MenuItem>
					{queues.map(queue => (
						<MenuItem key={queue.id} value={queue.id}>
							{queue.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default QueueSelectCustom;
